import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  Table,
  Input,
  Select,
  Button,
  Modal,
  InputNumber,
  Space,
  Tag,
  DatePicker,
} from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import CloseImage from "../../assets/images/newimages/close-fill.svg";
import RemamberImage from "../../assets/images/newimages/remamber-table-icon.svg";
import SearchOutlinedImg from "../../assets/images/newimages/search-line-icon.svg";
import GenerateReportImage from "../../assets/images/newimages/generate-report-image.svg";
import QuestionMarkImage from "../../assets/images/newimages/how-many-member-modal-image.svg";
import { useNavigate } from "react-router";
import { Calendar } from "lucide-react";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { debounce } from "lodash";

const { Option } = Select;

const getStatusTag = (status) => {
  switch (status) {
    case "Open":
      return <Tag color="blue">Open</Tag>;
    case "Closed":
      return <Tag color="purple">Closed</Tag>;
    case "PastDeadline":
      return <Tag color="red">Past Deadline</Tag>;
    default:
      return <Tag>{status}</Tag>;
  }
};
const { RangePicker } = DatePicker;
export default function ForLeader() {
  const [modalVisible, setModalVisible] = useState(false);
  const [teamMembers, setTeamMembers] = useState(1);
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const navigate = useNavigate();
  const { request } = useRequest();

  const debouncedFetch = useCallback(
    debounce((kw, status, range) => {
      fetchSurveys(kw, status, range);
    }, 500),
    []
  );
  const handleChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
    debouncedFetch(value, statusFilter, dateRange);
  };

  useEffect(() => {
    fetchSurveys();
  }, [keyword, statusFilter, dateRange]);

  const fetchSurveys = async (
    kw = keyword,
    status = statusFilter,
    range = dateRange
  ) => {
    setLoading(true);
    try {
      const query = new URLSearchParams();
      if (kw) query.append("keyword", kw);
      if (status && status !== "All Status") query.append("status", status);
      if (range.length === 2) {
        query.append("startDate", range[0]);
        query.append("endDate", range[1]);
      }
      query.append("surveyType", "Leader");

      request({
        // url: "/admin/mf/survey/list",
        url: `/admin/mf/survey/list?${query.toString()}`,
        method: "GET",
        onSuccess: (data) => {
          console.log(data, "data fetch here");
          setSurveys(data);
          setLoading(false);
        },
        onError: (error) => {
          ShowToast(
            error.response?.data?.message || "Failed to Fetch Survey",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } catch (err) {
      ShowToast(
        err.response?.data?.message || "Failed to load surveys",
        Severty.ERROR
      );
    }
    setLoading(false);
  };

  const handleLaunchClick = (record) => {
    navigate(`/tqforleaderform?surveyId=${record._id}`);
  };

  const columns = [
    {
      title: "Team Name",
      dataIndex: "teamName",
      key: "teamName",
    },
    {
      title: "Team Leader Name",
      dataIndex: "leader",
      key: "leader",
      render: (text, record) => (
        <div>
          <div>{record?.leader?.name}</div>
          <small>{record?.leader?.email}</small>
        </div>
      ),
    },
    {
      title: "#of Members",
      dataIndex: "members",
      key: "members",
      render: (members, record) => {
        if (!Array.isArray(members)) {
          return <div>0 members</div>;
        }
        const totalMembers = members.length;
        const pendingMembers = members.filter(
          (member) => member.status === "Pending"
        ).length;
        const completedMembers = members.filter(
          (member) => member.status === "Completed"
        ).length;
        return (
          <div>
            <div>{totalMembers} Total</div>
            <small>{completedMembers} Completed</small>
            <small> {pendingMembers} Pending</small>
          </div>
        );
      },
    },
    {
      title: "Due Date",
      dataIndex: "deadline",
      key: "deadline",
      render: (text) => {
        if (!text) {
          return null;
        }
        const date = new Date(text);
        const options = {
          month: "short",
          day: "numeric",
          year: "numeric",
        };
        return date.toLocaleDateString("en-US", options);
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: getStatusTag,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        return (
          <Space>
            {record.status === "Open" && (
              <>
                <Button
                  onClick={() => {
                    setLoading(true);
                    request({
                      url: "/admin/mf/survey/remind",
                      method: "POST",
                      data: { id: record._id },
                      onSuccess: (res) => {
                        ShowToast(res.message, Severty.SUCCESS);
                        setLoading(false);
                      },
                      onError: (err) => {
                        ShowToast(err.response?.data?.message, Severty.ERROR);
                        setLoading(false);
                      },
                    });
                  }}
                >
                  <img src={RemamberImage} />
                  {loading ? "Sending..." : "Remind"}
                  {/* Remind */}
                </Button>
                <Button
                  onClick={() => {
                    setLoading(true);
                    request({
                      url: `/admin/mf/survey/${record._id}/close`,
                      method: "PUT",
                      onSuccess: (res) => {
                        ShowToast(res.message, Severty.SUCCESS);
                        fetchSurveys();
                        setLoading(false);
                      },
                      onError: (err) => {
                        ShowToast(err.response?.data?.message, Severty.ERROR);
                        setLoading(false);
                      },
                    });
                  }}
                >
                  <img src={CloseImage} />
                  {loading ? "Closing..." : "Close"}
                </Button>
              </>
            )}
            {record.status === "Closed" && (
              <Button
                className="generate-report-button"
                onClick={() => {
                  setLoading(true);
                  request({
                    url: `/admin/mf/survey/report`,
                    method: "POST",
                    data: { id: record._id },
                    onSuccess: (res) => {
                      ShowToast(res.message, Severty.SUCCESS);
                      setLoading(false);
                    },
                    onError: (err) => {
                      ShowToast(err.response?.data?.message, Severty.ERROR);
                      setLoading(false);
                    },
                  });
                }}
              >
                <img src={GenerateReportImage} />
                Generate Report
              </Button>
            )}
            {record.status === "Review" && (
              <Button type="primary" onClick={() => handleLaunchClick(record)}>
                Launch
              </Button>
            )}
            {record.status === "PastDeadline" && (
              <Button
                onClick={() => {
                  setLoading(true);
                  request({
                    url: `/admin/mf/survey/${record._id}/close`,
                    method: "PUT",
                    onSuccess: (res) => {
                      ShowToast(res.message, Severty.SUCCESS);
                      fetchSurveys();
                      setLoading(false);
                    },
                    onError: (err) => {
                      ShowToast(err.response?.data?.message, Severty.ERROR);
                      setLoading(false);
                    },
                  });
                }}
              >
                <img src={CloseImage} />
                {loading ? "Closing..." : "Close"}
              </Button>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div>

      <Card
      extra={
        <>
          <Input.Search
               size="large"
            className="search-input"
            placeholder="Search team by name..."
            // prefix={<img src={SearchOutlinedImg} alt="Search Icon" />}
            style={{ width: 250 }}
          />
           <Select
              value={statusFilter}
              onChange={setStatusFilter}
            >
              <Option value="All Status">All Status</Option>
              <Option value="Open">Open</Option>
              <Option value="PastDeadline">Past Deadline</Option>
              <Option value="Closed">Closed</Option>
            </Select>
            <RangePicker
              format="YYYY-MM-DD"
              onChange={(dates) => {
                if (dates && dates.length === 2) {
                  setDateRange([
                    dates[0].format("YYYY-MM-DD"),
                    dates[1].format("YYYY-MM-DD"),
                  ]);
                  fetchSurveys();
                } else {
                  setDateRange([]);
                  fetchSurveys();
                }
              }}
            />
            <Button
          type="primary"
          icon={<PlusOutlined />}
          // onClick={() => navigate("/tqforleaderform")}
          onClick={() => setModalVisible(true)}
        >
          Launch new Survey
        </Button>
        </>
      }
        title={
          <>
            TPS for Leaders Surveys
            <p>Manage and track your Surveys</p>
          </>
        }
      >
        
        <div className="table-responsive">
          <Table
            columns={columns}
            dataSource={surveys}
            pagination={false}
            rowKey="key"
          />
        </div>
      </Card>
      <Modal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        centered
        closable={false}
        width={540}
        bodyStyle={{ textAlign: "center", padding: 24 }}
      >
        <div className="members-modal-main">
          <div className="question-mark-image">
            <img src={QuestionMarkImage} />
          </div>
          <p>How many members - including team leader - are in this team?</p>
          <div className="team-member-input">
            <InputNumber
              min={1}
              max={12}
              value={teamMembers}
              onChange={setTeamMembers}
              style={{ width: "100%" }}
            />
          </div>
          <div className="modal-footer-main">
            <Button onClick={() => setModalVisible(false)} type="link">
              Cancel
            </Button>
            <Button
              type="primary"
              // onClick={() => Navigate("/setupsurveysform")}
              onClick={() => {
                if (teamMembers < 3) {
                  return ShowToast(
                    "Minimum 3 members required to create survey!",
                    "error"
                  );
                }
                setModalVisible(false);
               const membersCount = teamMembers;
               navigate(`/tqforleaderform?members=${membersCount}`);
              }}
            >
              Continue
            </Button>
          </div>
        </div>
      </Modal>

      {/* <Modal
        open={paymentVisible}
        onCancel={() => setPaymentVisible(false)}
        footer={null}
        centered
        closable={false}
        width={500}
        bodyStyle={{ textAlign: "center", padding: 24 }}
      >
        <h3>Payment Required</h3>
        <p>Please complete your payment to launch the survey.</p>
        <div style={{ marginTop: 20 }}>
          <Button onClick={() => setPaymentVisible(false)}>Cancel</Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={() => {
              setPaymentVisible(false);
              ShowToast("Payment Successful!", Severty.SUCCESS);
              const membersCount = teamMembers;
              navigate(`/tqforleaderform?members=${membersCount}`);
            }}
          >
            Pay Now
          </Button>
        </div>
      </Modal> */}
    </div>
  );
}
